/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

export const REQUESTED_CUSTOM_ACCOUNT_GROUPS =
  'REQUESTED_CUSTOM_ACCOUNT_GROUPS';
export const requestedCustomAccountGroups = () => ({
  type: REQUESTED_CUSTOM_ACCOUNT_GROUPS
});

export const RECEIVED_CUSTOM_ACCOUNT_GROUPS = 'RECEIVED_CUSTOM_ACCOUNT_GROUPS';
export const receivedCustomAccountGroups = (customAccountGroups = []) => ({
  type: RECEIVED_CUSTOM_ACCOUNT_GROUPS,
  customAccountGroups
});

export const ERROR_CUSTOM_ACCOUNT_GROUPS = 'ERROR_CUSTOM_ACCOUNT_GROUPS';
export const errorCustomAccountGroups = () => ({
  type: ERROR_CUSTOM_ACCOUNT_GROUPS
});

export const REFRESH_CUSTOM_ACCOUNT_GROUPS = 'REFRESH_CUSTOM_ACCOUNT_GROUPS';
export const refreshCustomAccountGroups = () => ({
  type: REFRESH_CUSTOM_ACCOUNT_GROUPS
});

export const ALL_ACCOUNT_SELECTION_CHANGE = 'ALL_ACCOUNT_SELECTION_CHANGE';
export const selectAllClearAllAccounts = (accountDescriptors = []) => ({
  type: ALL_ACCOUNT_SELECTION_CHANGE,
  accountDescriptors
});

export const UPDATE_CUSTOM_ACCOUNT_GROUP = 'UPDATE_CUSTOM_ACCOUNT_GROUP';
export const updateCustomAccountGroup = (field, value) => ({
  type: UPDATE_CUSTOM_ACCOUNT_GROUP,
  field,
  value
});

export const SET_CUSTOM_ACCOUNT_GROUP = 'SET_NEW_CUSTOM_ACC_GROUP';
export const setCustomAccount = (groupId) => ({
  type: SET_CUSTOM_ACCOUNT_GROUP,
  groupId
});

export const GET_CUSTOM_ACCOUNT_GROUP_DATA = 'GET_CUSTOM_ACCOUNT_GROUP_DATA';
export const getCustomAccountGroup = (selection) => ({
  type: GET_CUSTOM_ACCOUNT_GROUP_DATA,
  selection
});

export const ACCOUNT_SELECTION_CHANGE = 'ACCOUNT_SELECTION_CHANGE';
export const changeAccountSelection = (accountDescriptor, group = {}) => ({
  type: ACCOUNT_SELECTION_CHANGE,
  accountDescriptor,
  group
});

export const HIDE_SHOW_CHANGED = 'HIDE_SHOW_CHANGED';
export const hideShowUpdated = (accountDetails) => ({
  type: HIDE_SHOW_CHANGED,
  payload: {
    accountDetails: accountDetails
  }
});

export const HIDE_SHOW_ALL = 'HIDE_SHOW_ALL';
export const hideShowAll = (hideOrShow) => ({
  type: HIDE_SHOW_ALL,
  hideOrShow
});

export const REQUESTED_CUSTOMER_PREFERENCES = 'REQUESTED_CUSTOMER_PREFERENCES';
export const requestedCustomerPreferences = () => ({
  type: REQUESTED_CUSTOMER_PREFERENCES
});

export const RECEIVED_CUSTOMER_PREFERENCES = 'RECEIVED_CUSTOMER_PREFERENCES';
export const receivedCustomerPreferences = (preferences) => ({
  type: RECEIVED_CUSTOMER_PREFERENCES,
  preferences
});

export const ERROR_CUSTOMER_PREFERENCES = 'ERROR_CUSTOMER_PREFERENCES';
export const errorCustomerPreferences = (error) => ({
  type: ERROR_CUSTOMER_PREFERENCES,
  error
});

export const REQUESTED_UPDATE_CUSTOMER_PREFERENCES =
  'REQUESTED_UPDATE_CUSTOMER_PREFERENCES';
export const requestedUpdateCustomerPreferences = () => ({
  type: REQUESTED_UPDATE_CUSTOMER_PREFERENCES
});

export const RECEIVED_UPDATE_CUSTOMER_PREFERENCES =
  'RECEIVED_UPDATE_CUSTOMER_PREFERENCES';
export const receivedUpdateCustomerPreferences = (preferences) => ({
  type: RECEIVED_UPDATE_CUSTOMER_PREFERENCES,
  preferences
});

export const RESET_ACCOUNT_VISIBILITY = 'RESET_ACCOUNT_VISIBILITY';
export const resetAccountVisibility = () => ({
  type: RESET_ACCOUNT_VISIBILITY
});

export const ACCOUNTS_VISIBILITY_UPDATED = 'ACCOUNTS_VISIBILITY_UPDATED';
export const accountVisibilityUpdated = () => ({
  type: ACCOUNTS_VISIBILITY_UPDATED
});
export const ERROR_ACCOUNT_VISIBILITY = 'ERROR_ACCOUNT_VISIBILITY';
export const errorUpdateAccountVisibility = () => ({
  type: ERROR_ACCOUNT_VISIBILITY
});

export const ERROR_UPDATE_CUSTOMER_PREFERENCES =
  'ERROR_UPDATE_CUSTOMER_PREFERENCES';
export const errorUpdateCustomerPreferences = (error) => ({
  type: ERROR_UPDATE_CUSTOMER_PREFERENCES,
  error
});

export const DIVIDENDS_CAPITAL_GAINS_BUSINESS_EVENT = 'DISPATCH_BUSINESS_EVENT';
export const sendDivCapBusinessEvent = (payload) => ({
  type: DIVIDENDS_CAPITAL_GAINS_BUSINESS_EVENT,
  payload
});

export const REQUESTED_DIVIDENDS_CAPITAL_GAINS =
  'REQUESTED_DIVIDENDS_CAPITAL_GAINS';
export const requestedDividendsAndCapitalGains = () => ({
  type: REQUESTED_DIVIDENDS_CAPITAL_GAINS
});

export const RECEIVED_DIVIDENDS_CAPITAL_GAINS =
  'RECEIVED_DIVIDENDS_CAPITAL_GAINS';
export const receivedDividendsAndCapitalGains = (dividendsAndCapitalGains) => ({
  type: RECEIVED_DIVIDENDS_CAPITAL_GAINS,
  dividendsAndCapitalGains
});

export const UPDATE_DISTRIBUTION_TO_EDIT = 'UPDATE_DISTRIBUTION_TO_EDIT';
export const updateDistributionToEdit = (distribution) => ({
  type: UPDATE_DISTRIBUTION_TO_EDIT,
  distribution
});

export const ERROR_DIVIDENDS_CAPITAL_GAINS = 'ERROR_DIVIDENDS_CAPITAL_GAINS';
export const errorDividendsAndCapitalGains = (error) => ({
  type: ERROR_DIVIDENDS_CAPITAL_GAINS,
  error
});

export const REQUESTED_AVAILABLE_FUNDS = 'REQUESTED_AVAILABLE_FUNDS';
export const requestedAvailableFunds = () => ({
  type: REQUESTED_AVAILABLE_FUNDS
});

export const RECEIVED_AVAILABLE_FUNDS = 'RECEIVED_AVAILABLE_FUNDS';
export const receivedAvailableFunds = (availableFunds) => ({
  type: RECEIVED_AVAILABLE_FUNDS,
  availableFunds
});

export const ERROR_AVAILABLE_FUNDS = 'ERROR_AVAILABLE_FUNDS';
export const errorAvailableFunds = (error) => ({
  type: ERROR_AVAILABLE_FUNDS,
  error
});

export const REQUESTED_UPDATE_DIVIDENDS_CAPITAL_GAINS =
  'REQUESTED_UPDATE_DIVIDENDS_CAPITAL_GAINS';
export const requestedUpdateDividendsAndCapitalGains = () => ({
  type: REQUESTED_UPDATE_DIVIDENDS_CAPITAL_GAINS
});

export const RECEIVED_UPDATE_DIVIDENDS_CAPITAL_GAINS =
  'RECEIVED_UPDATE_DIVIDENDS_CAPITAL_GAINS';
export const receivedUpdateDividendsAndCapitalGains = (
  dividendsAndCapitalGains
) => ({
  type: RECEIVED_UPDATE_DIVIDENDS_CAPITAL_GAINS,
  dividendsAndCapitalGains
});

export const RECEIVED_UPDATE_MUTUAL_FUND_DIVIDENDS_CAPITAL_GAINS =
  'RECEIVED_UPDATE_MUTUAL_FUND_DIVIDENDS_CAPITAL_GAINS';
export const receivedUpdateMutualFundDividendsAndCapitalGains = (
  dividendsAndCapitalGains
) => ({
  type: RECEIVED_UPDATE_MUTUAL_FUND_DIVIDENDS_CAPITAL_GAINS,
  dividendsAndCapitalGains
});

export const ERROR_UPDATE_DIVIDENDS_CAPITAL_GAINS =
  'ERROR_UPDATE_DIVIDENDS_CAPITAL_GAINS';
export const errorUpdateDividendsAndCapitalGains = (error) => ({
  type: ERROR_UPDATE_DIVIDENDS_CAPITAL_GAINS,
  error
});

export const DISPATCH_BUSINESS_EVENT = 'DISPATCH_BUSINESS_EVENT';
export const dispatchBusinessEvent = (payload) => ({
  type: DISPATCH_BUSINESS_EVENT,
  payload
});

export const UPDATE_COMPLIANCE_SUBSCRIPTION = 'UPDATE_COMPLIANCE_SUBSCRIPTION';
export const updateComplianceSubscription = (emailAddress) => ({
  type: UPDATE_COMPLIANCE_SUBSCRIPTION,
  emailAddress
});

export const ERROR_MUTUAL_FUNDS = 'ERROR_MUTUAL_FUNDS';
export const errorMutualFunds = (error) => ({
  type: ERROR_MUTUAL_FUNDS,
  error
});

export const RECEIVED_MUTUAL_FUNDS = 'RECEIVED_MUTUAL_FUNDS';
export const receivedMutualFunds = (mutualFunds) => ({
  type: RECEIVED_MUTUAL_FUNDS,
  mutualFunds
});

export const REQUESTED_MUTUAL_FUNDS = 'REQUESTED_MUTUAL_FUNDS';
export const requestedMutualFunds = () => ({
  type: REQUESTED_MUTUAL_FUNDS
});

export const RECEIVED_DOCUMENT_DELIVERY = 'RECEIVED_DOCUMENT_DELIVERY';
export const receivedDocumentDelivery = (subscriptions) => ({
  type: RECEIVED_DOCUMENT_DELIVERY,
  subscriptions
});

export const REQUESTED_DOCUMENT_DELIVERY = 'REQUESTED_DOCUMENT_DELIVERY';
export const requestedDocumentDelivery = () => ({
  type: REQUESTED_DOCUMENT_DELIVERY
});

export const ERROR_DOCUMENT_DELIVERY = 'ERROR_DOCUMENT_DELIVERY';
export const errorDocumentDelivery = (error) => ({
  type: ERROR_DOCUMENT_DELIVERY,
  error
});

export const ERROR_UPDATE_DOCUMENT_DELIVERY = 'ERROR_UPDATE_DOCUMENT_DELIVERY';
export const errorUpdateDocumentDelivery = (error) => ({
  type: ERROR_UPDATE_DOCUMENT_DELIVERY,
  error
});

export const RECEIVED_UPDATE_DOCUMENT_DELIVERY =
  'RECEIVED_UPDATE_DOCUMENT_DELIVERY';
export const receivedUpdateDocumentDelivery = (
  subscriptions,
  requestResult
) => ({
  type: RECEIVED_UPDATE_DOCUMENT_DELIVERY,
  requestResult,
  subscriptions
});

export const RECEIVED_CASCADING_SUBSCRIPTIONS =
  'RECEIVED_CASCADING_SUBSCRIPTIONS';
export const receivedCascadingSubscriptions = (
  subscriptions,
  requestResult
) => ({
  type: RECEIVED_CASCADING_SUBSCRIPTIONS,
  requestResult,
  subscriptions
});

export const REQUESTED_UPDATE_DOCUMENT_DELIVERY =
  'REQUESTED_UPDATE_DOCUMENT_DELIVERY';
export const requestedUpdateDocumentDelivery = () => ({
  type: REQUESTED_UPDATE_DOCUMENT_DELIVERY
});

export const REQUESTED_CASCADING_SUBSCRIPTIONS =
  'REQUESTED_CASCADING_SUBSCRIPTIONS';
export const requestedCasCadingSubscriptions = () => ({
  type: REQUESTED_CASCADING_SUBSCRIPTIONS
});

export const ERROR_SUBSCRIPTIONS = 'ERROR_SUBSCRIPTIONS';
export const errorSubscriptions = (error) => ({
  type: ERROR_SUBSCRIPTIONS,
  error
});

export const RECEIVED_SUBSCRIPTIONS = 'RECEIVED_SUBSCRIPTIONS';
export const receivedSubscriptions = (subscriptions) => ({
  type: RECEIVED_SUBSCRIPTIONS,
  subscriptions
});

export const REQUESTED_SUBSCRIPTIONS = 'REQUESTED_SUBSCRIPTIONS';
export const requestedSubscriptions = () => ({
  type: REQUESTED_SUBSCRIPTIONS
});

export const CHANGE_SELECTED_DEFAULT_START_PAGE =
  'CHANGE_SELECTED_DEFAULT_START_PAGE';
export const changeSelectedDefaultStartPage = (selection) => ({
  type: CHANGE_SELECTED_DEFAULT_START_PAGE,
  selection
});

export const CHANGE_SELECTED_DEFAULT_GROUP_ID =
  'CHANGE_SELECTED_DEFAULT_GROUP_ID';
export const changeSelectedDefaultGroupId = (selection) => ({
  type: CHANGE_SELECTED_DEFAULT_GROUP_ID,
  selection
});

export const DISABLE_CONTACT_INFO_SAVE = 'DISABLE_CONTACT_INFO_SAVE';
export const disableContactInfoSave = () => ({
  type: DISABLE_CONTACT_INFO_SAVE
});

export const ENABLE_CONTACT_INFO_SAVE = 'ENABLE_CONTACT_INFO_SAVE';
export const enableContactInfoSave = () => ({
  type: ENABLE_CONTACT_INFO_SAVE
});

export const HIDE_FIXED_FOOTER_SAVE_OPTIONS = 'HIDE_FIXED_FOOTER_SAVE_OPTIONS';
export const hideFixedFooterSaveOptions = () => ({
  type: HIDE_FIXED_FOOTER_SAVE_OPTIONS
});

export const SHOW_FIXED_FOOTER_SAVE_OPTIONS = 'SHOW_FIXED_FOOTER_SAVE_OPTIONS';
export const showFixedFooterSaveOptions = () => ({
  type: SHOW_FIXED_FOOTER_SAVE_OPTIONS
});

export const ERROR_UPDATE_CONTACT_INFORMATION =
  'ERROR_UPDATE_CONTACT_INFORMATION';
export const errorUpdateContactInformation = () => ({
  type: ERROR_UPDATE_CONTACT_INFORMATION
});

export const ERROR_UPDATE_TRUSTED_CONTACTS = 'ERROR_UPDATE_TRUSTED_CONTACTS';
export const errorUpdateTrustedContacts = () => ({
  type: ERROR_UPDATE_TRUSTED_CONTACTS
});

export const UPDATE_IS_MAILING_ADDRESS_SAME_AS_RESIDENTIAL =
  'UPDATE_IS_MAILING_ADDRESS_SAME_AS_RESIDENTIAL';
export const updateIsMailingAddressSameAsResidential = (isChecked) => ({
  type: UPDATE_IS_MAILING_ADDRESS_SAME_AS_RESIDENTIAL,
  isChecked
});

export const REQUESTED_PAPERLESS_DISCLOSURE = 'REQUESTED_PAPERLESS_DISCLOSURE';
export const requestedPaperlessDisclosure = () => ({
  type: REQUESTED_PAPERLESS_DISCLOSURE
});

export const RECEIVED_PAPERLESS_DISCLOSURE = 'RECEIVED_PAPERLESS_DISCLOSURE';
export const receivedPaperlessDisclosure = () => ({
  type: RECEIVED_PAPERLESS_DISCLOSURE
});

export const ERROR_PAPERLESS_DISCLOSURE = 'ERROR_PAPERLESS_DISCLOSURE';
export const errorPaperlessDisclosure = () => ({
  type: ERROR_PAPERLESS_DISCLOSURE
});
